<template>
	<div class="evaluate-page">
		<Head position="absolute" mode="white" :isHaveBack="true" @back="backHead"></Head>
		<!-- 横幅 -->
		<div class="banner">
			<div class="content w1360 animate__animated animate__fadeInUp">
				<div class="heading">{{fuwuInfo.title || ''}}</div>
				<!-- <div class="des">以标准锚定绿色航向，用评价驱动产业转型，为全球供应链贡献中国低碳方案</div> -->
				<div class="btns">
					<el-button class="lijishiyong" type="whitetrans" @click="apply">立即申请</el-button>
				</div>
			</div>
		</div>
		<!-- 服务介绍 -->
		<div class="wow animate__slideInUp" data-wow-duration="1.5s">
			<div class="serviceIntroduce">
				<div class="serviceIntroduce-container w1200">
					<div class="heading">服务介绍</div>
					<div class="heading-des">
						内置集装箱绿色产品评价功能模块，构建涵盖资源、能源、环境、品质和低碳五个维度的绿色产品评价体系，科学评价绿色产品和绿色标杆产品，实现企业申请、资料填报及上传、资料审核、证书发放等一站式服务。
					</div>
				</div>
			</div>
		</div>
		<!-- 绿色产品评价体系导向 -->
		<div class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
			<div class="goujianfangxiang">
				<div class="heading">绿色产品评价体系导向</div>
				<div class="list">
					<div class="item" v-for="(item, index) in evaluateDirection" :key="index">
						<div class="icon">
							<svg-icon :name="item.icon"></svg-icon>
						</div>
						<div class="content">
							<div class="label">{{ item.label }}</div>
							<div class="des">{{ item.des }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 评价标准及意义 -->
		<div class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
			<div class="biaozhunyiyi">
				<div class="biaozhunyiyi-container w1360">
					<div class="heading">评价标准及意义</div>
					<div class="biaozhunyiyi-content">
						<div class="list">
							<div class="item">
								<div class="icon">
									<svg-icon :name="evaluateYiyi[0].icon"></svg-icon>
								</div>
								<div class="content">
									<div class="label">{{evaluateYiyi[0].label}}</div>
									<div class="des">{{evaluateYiyi[0].des}}</div>
								</div>
							</div>
							<div class="item">
								<div class="icon">
									<svg-icon :name="evaluateYiyi[1].icon"></svg-icon>
								</div>
								<div class="content">
									<div class="label">{{evaluateYiyi[1].label}}</div>
									<div class="des">{{evaluateYiyi[1].des}}</div>
								</div>
							</div>
						</div>
						<div class="card">
							<div class="label">{{evaluateYiyi[2].label}}</div>
							<div class="des">{{evaluateYiyi[2].des}}</div>
							<!-- <div class="green-text">推动集装箱行业的绿色低碳发展</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 集装箱绿色评价证书 -->
		<div v-if="false" class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
			<!-- 		<div class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s"> -->
			<div class="zhengshu">
				<div class="zhengshu-container ">
					<div class="heading">集装箱绿色评价证书</div>
					<div class="swiper swiper-container">
						<div class="swiper-wrapper">
							<div class="swiper-slide item" v-for="(item, index) in swiperList">
								<el-image 
								    class="img"
								    :src="pingjiazhengshu" 
								    :preview-src-list="[pingjiazhengshu]">
								  </el-image>
							</div>
						</div>
					</div>
					<div class="swiper-btns">
						<div class="prev" :class="{ end: virtualIndex <= 5 }" @click="slidePrev">
							<svg-icon name="arrow5"></svg-icon>
						</div>
						<div class="next" :class="{ end: virtualIndex >= swiperList.length }" @click="slideNext">
							<svg-icon name="arrow6"></svg-icon>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import { webInfo } from '@/common/data.js';
	import pingjiazhengshu from '@/assets/tmp/031.jpg'
import { evaluateYiyi, evaluateDirection } from '@/common/data.js';
import Head from '@/layout/Head/Head.vue';
import Foot from '@/layout/Foot/Foot.vue';
import { WOW } from 'wowjs';
import Swiper from 'swiper'; // 注意引入的是Swiper
import 'swiper/css/swiper.min.css'; // 注意这里的引入
export default {
	name: 'evaluate',
	components: { Head, Foot },
	data() {
		return {
			// swiper实例  实例上有各种方法
			swiperInstance: null,
			swiperList: [{}, {}, {}, {}, {}, {}, {}],
			// swiperList: [{},{},{},{},{},{},{},{},{},{},{},{},],
			virtualIndex: 5,
			// 绿色产品评价体系导向
			evaluateDirection: evaluateDirection,
			// 评价标准及意义
			evaluateYiyi: evaluateYiyi,
			// 评价证书
			pingjiazhengshu: pingjiazhengshu,
			fuwuInfo: webInfo.sidafuwu[3]
		};
	},
	created() {},
	mounted() {
		this.$nextTick(() => {
			new WOW({
				boxClass: 'wow',
				animateClass: 'animate__animated',
				offset: 100,
				mobile: true,
				live: true,
				// callback: function (c) {
				//     console.log(c, 'sss')
				// },
				scrollContainer: null,
				resetAnimation: true
			}).init();
		});

		let _that = this;
		this.swiperInstance = new Swiper('.swiper-container', {
			// config...
			//根据slider的宽度自动分布
			loop: false,
			slidesPerView: 'auto',
			on: {
				slideChange: function (e) {
					console.log('this.realIndex: ', this.realIndex);
					_that.virtualIndex = this.realIndex + 5;
					console.log('_that.virtualIndex: ', _that.virtualIndex);
				}
			}
		});
	},
	methods: {
		backHead() {
			this.$router.go(-1);
		},
		apply() {
			if (this.checkUser()) {
				if (this.uInfo && this.uInfo.roles && this.uInfo.certifiedStatus == '2') {
					if (this.uInfo.isAdmin) {
						window.open('/org/home/#/enterprise/greenEvaluation', '_self');
					// } else if (
					// 	(!this.uInfo.isAdmin &&
					// 		this.uInfo.roles &&
					// 		(this.uInfo.roles.indexOf('manager') != -1 ||
					// 			this.uInfo.username.indexOf('AdminMaster01') != -1 ||
					// 			this.uInfo.username.indexOf('AdminMaster02') != -1)) ||
					// 	this.uInfo.roles.indexOf('manager_userSet') != -1
					// ) {
					// 	window.open('/org/admin/', '_self');
					// } else if (!this.uInfo.isAdmin && this.uInfo.roles && this.uInfo.roles.indexOf('government') != -1) {
					// 	window.open('/org/admin/', '_self');
					// } else if (!this.uInfo.isAdmin && this.uInfo.roles && (this.uInfo.roles.indexOf('authentication') != -1 || this.uInfo.roles.indexOf('auth_userSet') != -1)) {
					// 	window.open('/org/authority/', '_self');
					} else if (!this.uInfo.isAdmin && this.uInfo.roles && (this.uInfo.roles.indexOf('company') != -1 || this.uInfo.roles.indexOf('home_userSet') != -1)) {
						window.open('/org/home/#/enterprise/greenEvaluation', '_self');
					} else {
						this.toast({
							type: 'warning',
							message: '暂无进入企业端角色权限，请联系管理员'
						});
					}
				} else if (this.uInfo && this.uInfo.certifiedStatus) {
					if (this.uInfo.certifiedStatus == 1) {
						this.toast({
							type: 'warning',
							message: '实名审核中，请等待审核结果'
						});
					} else if (this.uInfo.certifiedStatus == 2) {
						this.toast({
							type: 'warning',
							message: '暂无进入工作台角色权限，请联系管理员'
						});
					} else if (this.uInfo.certifiedStatus == 3) {
						this.toast({
							type: 'warning',
							message: '实名失败，请重新提交'
						});
					}
				}
			} else {
				this.toast({
					type: 'warning',
					message: '请先登录'
				});
				this.$router.push({
					name: 'login'
				});
			}
		},
		slidePrev() {
			if (this.virtualIndex > 5) {
				// this.swiperInstance.slidePrev()
				this.virtualIndex--;
				this.swiperInstance.slideTo(this.virtualIndex - 5);
				console.log('this.virtualIndex: ', this.virtualIndex);
			}
		},
		slideNext() {
			if (this.virtualIndex < this.swiperList.length) {
				// this.swiperInstance.slideNext()
				this.virtualIndex++;
				this.swiperInstance.slideTo(this.virtualIndex - 5);
				console.log('this.virtualIndex: ', this.virtualIndex);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.evaluate-page {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	position: relative;
	.banner {
		// margin-top: -$head-height;
		background-image: url('~@/assets/tmp/030.png');
		background-size: cover;
		height: 334px;
		.content {
			display: flex;
			flex-direction: column;
			padding-left: 50px;
			box-sizing: border-box;
			.heading {
				margin-top: 93px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 36px;
				color: #ffffff;
				line-height: 52px;
			}
			.des {
				margin-top: 17px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 18px;
				color: #ffffff;
				line-height: 22px;
			}
			.btns {
				margin-top: 40px;
				display: flex;
				.lijishiyong {
					display: flex;
					justify-content: center;
					align-items: center;
					padding: 0;
					width: 160px;
					height: 50px;
					border-radius: 0px;
					// font-weight: bold;
					font-size: 16px;
					line-height: 22px;
				}
			}
		}
	}
	
	.serviceIntroduce {
		background: #f6f8fc;
		padding-bottom: 45px;
		.serviceIntroduce-container {
			display: flex;
			flex-direction: column;
			align-items: center;
			.heading {
				margin-top: 40px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 28px;
				color: #000000;
				line-height: 52px;
			}
			.heading-des {
				width: 1164px;
				line-height: 30px;
				margin-top: 20px;
				font-size: 18px;
				color: #636d7e;
				text-align: justify;
				text-align-last: center;
			}
			
		}
	}

	.goujianfangxiang {
		padding-top: 45px;
		padding-bottom: 45px;
		display: flex;
		flex-direction: column;
		.heading {
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 34px;
			color: #000000;
			line-height: 52px;
			text-align: center;
		}
		.list {
			margin-top: 47px;
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			.item {
				width: calc(100% / 3);
				display: flex;
				height: 223px;
				background: #ffffff;
				border: 1px solid rgba(223, 223, 223, 0.7);
				padding-top: 60px;
				padding-bottom: 60px;
				box-sizing: border-box;
				.icon {
					width: 152px;
					display: flex;
					justify-content: flex-end;
					padding-right: 30px;
					box-sizing: border-box;
					.svg-shuye {
						width: 33px;
						height: 33px;
					}
					.svg-liangbei {
						width: 30px;
						height: 33px;
					}
					.svg-lujing {
						width: 30px;
						height: 33px;
					}
					.svg-shuidi {
						width: 25px;
						height: 34px;
					}
					.svg-zuji {
						width: 32px;
						height: 32px;
					}
				}
				.content {
					flex: 1;
					display: flex;
					flex-direction: column;
					padding-right: 33px;
					.label {
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 24px;
						color: #262729;
						line-height: 33px;
					}
					.des {
						margin-top: 23px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 14px;
						color: rgba(#262729, 0.7);
						line-height: 20px;
						text-align: justify;
					}
				}
			}
		}
	}

	.biaozhunyiyi {
		padding-top: 62px;
		padding-bottom: 60px;
		background: #f9fafb;
		.biaozhunyiyi-container {
			display: flex;
			flex-direction: column;
			.heading {
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 34px;
				color: #000000;
				line-height: 52px;
				text-align: center;
			}
			.biaozhunyiyi-content {
				margin-top: 66px;
				display: flex;
				.list {
					flex: 1;
					padding-right: 113px;
					.item {
						margin-top: 80px;
						display: flex;
						&:first-child {
							margin-top: 26px;
						}
						.icon {
							padding-left: 33px;
							padding-right: 44px;
							.svg-icon {
								width: 50px;
								height: 50px;
							}
						}
						.content {
							display: flex;
							flex-direction: column;
							.label {
								font-family: PingFangSC, PingFang SC;
								font-weight: 500;
								font-size: 24px;
								color: #262729;
								line-height: 33px;
							}
							.des {
								margin-top: 19px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 400;
								font-size: 14px;
								color: rgba(#262729, 0.7);
								line-height: 20px;
								text-align: justify;
							}
						}
					}
				}
				.card {
					width: 656px;
					background: #ffffff;
					display: flex;
					flex-direction: column;
					padding-top: 54px;
					padding-left: 57px;
					padding-right: 86px;
					padding-bottom: 36px;
					box-sizing: border-box;
					.label {
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 24px;
						color: #262729;
						line-height: 33px;
					}
					.des {
						margin-top: 23px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 14px;
						color: rgba(#262729, 0.7);
						line-height: 20px;
						text-align: justify;
					}
					.green-text {
						margin-top: 32px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 17px;
						color: #29965c;
						line-height: 24px;
					}
				}
			}
		}
	}

	.zhengshu {
		padding-top: 46px;
		padding-bottom: 50px;
		.zhengshu-container {
			display: flex;
			flex-direction: column;
			.heading {
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 34px;
				color: #000000;
				line-height: 52px;
				text-align: center;
			}
			.swiper {
				margin-top: 69px;
				width: 100%;
				padding: 0 40px;
				box-sizing: border-box;
				.swiper-wrapper {
					width: 100%;
					display: flex;
					margin-left: calc((100% - (250px * 5)) / 8 * -1);
					padding: 20px 0;
					.item {
						width: 250px;
						height: 340px;
						margin: 0 calc((100% - (250px * 5)) / 8);
						&:hover {
							.img {
								transform: scale(1.05);
							}
						}
						.img {
							transition: all 0.3s ease;
							width: 100%;
							height: 100%;
						}
						
					}
				}
			}
			.swiper-btns {
				margin-top: 50px;
				display: flex;
				justify-content: center;
				.prev {
					padding: 15px;
					cursor: pointer;
					&:hover {
						.svg-icon {
							stroke: $primary;
						}
					}
					&.end {
						.svg-icon {
							stroke: #a5a9b1;
						}
					}
					.svg-icon {
						width: 20px;
						height: 15px;
						stroke: #666;
					}
				}
				.next {
					padding: 15px;
					cursor: pointer;
					&:hover {
						.svg-icon {
							stroke: $primary;
						}
					}
					&.end {
						.svg-icon {
							stroke: #a5a9b1;
						}
					}
					.svg-icon {
						width: 20px;
						height: 15px;
						stroke: #666;
					}
				}
			}
		}
	}
}
</style>
